module.exports = __webpack_public_path__ + "img/home-right-background.a7f6c16c.png";